<template>
  <!-- 企业招聘 -->
  <div class="box">
    <!-- 头部 -->
    <div class="logoTop">
      <span><img src="../../assets/anluoyun.png" alt="" style="width:13%" /></span>
      <span @click="viewList()"><van-icon name="bars" /></span>
    </div>
    <van-popup
      v-model="tabShow"
      class="tabShow"
      position="right"
      :style="{ height: '100%' }"
    >
      <div style="margin:15px"> 
        <img src="../../assets/anluoyun.png" alt="" style="width:80%;margin:0 10%">
      </div>
      <ul>
        <li><router-link to="/anLuoYun">网站首页</router-link></li>
        <li>
          <router-link to="/anLuoYun/about">关于我们</router-link>
        </li>
        <li><router-link to="/anLuoYun/serve">企业项目</router-link></li>
        <li class="select"><router-link to="/anLuoYun/recruit">企业招聘</router-link></li>
        <li><router-link to="/anLuoYun/message">企业资讯</router-link></li>
        <li><router-link to="/anLuoYun/contact">联系我们</router-link></li>
      </ul>
    </van-popup>
    <!-- 标题 -->
    <div class="title">
      企业招聘
    </div>
    <!-- 内容 -->
    <article class="center">
      <div class="boxList">
        <div class="clearfix"><span style="color:#2196f3">前端开发工程师</span><span style="color:red">¥4000~8000元</span></div>
        <div style="line-height:20px" class="requirement">
          <ul>
            <li>1、 使用Div+css并结合Javascript负责产品的前端开发和页面制作。</li>
            <li>2、 熟悉W3C标准和各主流浏览器在前端开发中的差异，能熟练运用DIV+CSS，提供针对不同浏览器的前端页面解决方案。移动HTML5的性能和其他优化，为用户呈现最好的界面交互体验和最好的性能。</li>
            <li>3、 负责相关产品的需求以及前端程序的实现，提供合理的前端架构。改进和优化开发工具、开发流程、和开发框架。</li>
            <li>4、 与产品、后台开发人员保持良好沟通，能快速理解、消化各方需求，并落实为具体的开发工作；能独立完成功能页面的设计与代码编写，配合产品团队完成功能页面的需求调研和分析。</li>
            <li>5、 了解服务器端的相关工作，在交互体验、产品设计等方面有自己的见解。</li>
          </ul>
        </div>
      </div>
      <div class="boxList">
        <div class="clearfix"><span style="color:#2196f3">后端工程师</span><span style="color:red">¥4000~8000元</span></div>
        <div style="line-height:20px" class="requirement">
          <ul>
            <li>1、 完成软件的设计、实现、测试、修改bug等工作，包括业务需求的沟通，功能模块详细设计，业务功能实现与单元测试，系统维护；</li>
            <li>2、 参与产品构思和架构设计；</li>
            <li>3、 撰写相关的技术文档；</li>
            <li>4、 编写项目需求文档。</li>
          </ul>
        </div>
      </div>
    </article>
      <!-- 底部 -->
    <aside class="buttonVal">
      <div>电 话：18837992186</div>
      <div>地 址：洛阳市经济技术开发区长夏门街32号863创智广场1 幢2201</div>
      <div>版 权：河南安洛云信息科技有限公司</div>
      <div>备案号：豫ICP备17050318号-1</div>
    </aside>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabShow: false,
    };
  },
  methods: {
    // 顶部tab菜单显示
    viewList() {
      if (this.tabShow == true) {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
    },
    pushTo(row) {},
  },
};
</script>
<style scoped>
.logoTop {
  z-index: 2;
  position: fixed;
  top: 0;
  width: 100%;
  height: 65px;
  background: #fff;
  box-shadow: 0px 1px 5px #ccc;
}
.logoTop span:nth-child(1) {
  position: absolute;
  left: 15px;
  top: 10px;
}
.logoTop span:nth-child(2) {
  position: absolute;
  right: 15px;
  top: 13px;
  font-size: 37px;
}
.tabShow {
  width: 130px;
}
.tabShow li {
  padding: 8px 0px;
  text-align: center;
  color: #000;
}
.tabShow a {
  color: #000;
}
.tabShow .select {
  background: #ccc;
}
.tabShow .select a {
  color: #0076f6;
}
.title {
  margin: 90px 15px 0 15px;
  font-size: 18px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 2px solid #2196f3;
}
.center {
  position: relative;
  margin-top: 5px;
  height: 60%;
  overflow-y: scroll;
}
.buttonVal {
  width: 100%;
  height: 18%;
  position: fixed;
  bottom: 0px;
  padding: 8px 15px;
  background: #333333;
  font-size: 14px;
  color: #fff;
}
.buttonVal div {
  margin: 5px;
}
.child-view {
  height: 100%;
}
.boxList {
  font-size: 15px;
  line-height: 30px;
  padding: 8px 15px;
  border-bottom: 1px dashed #ccc;
}
.boxList div span:nth-child(1){
  float: left;
}
.boxList div span:nth-child(2){
  float: right;
}
.boxList div:nth-child(2){
  font-size: 12px;
}
</style>